import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EnvironmentSpecificService } from '../../environment-specific.service';
import { Http } from '../shared/http-client/http-client.component';
import { AppForPublicSocket } from '../../app.module';

@Injectable()
export class PublicSharedLiveService {


  apiUrl: any;
  developmentEnv:boolean = true;

  constructor(
    private http: Http,
    private _http: HttpClient,
    private _envService: EnvironmentSpecificService,
    private _appSocket: AppForPublicSocket
    ) {
      
      this.apiUrl = this._envService.envSpecific.apiUrl;
      this.developmentEnv = this._envService.envSpecific.developmentEnv;

    }

     SocketConnect(token){
        this._appSocket.connect(token);
     }
    
    RequestStartStreaming(){
        this._appSocket.getSocket().emit("RequestStartStreamingByAnonymous");
    }

    RequestStopStreaming(){
        this._appSocket.getSocket().emit("RequestStopStreamingByAnonymous");
    }

     IsDeviceOnline(){
        this._appSocket.getSocket().emit("isdeviceonline");
    }

    GetResponseStream = () =>{
      return Observable.create((observer) => {
         if (this._appSocket.getSocket().listeners != null && this._appSocket.getSocket().listeners['connect'])  this._appSocket.getSocket().removeListener('connect');
            this._appSocket.getSocket().on('connect', () => {
                observer.next({type:'connect'});
            });
             if (this._appSocket.getSocket().listeners != null && this._appSocket.getSocket().listeners['livedeviceoffline'])  this._appSocket.getSocket().removeListener('livedeviceoffline');
            this._appSocket.getSocket().on('livedeviceoffline', (message) => {
                observer.next({type:'livedeviceoffline',data: JSON.parse(message)});
            });
            if (this._appSocket.getSocket().listeners != null && this._appSocket.getSocket().listeners['ResponseStartStreamByAnonymous'])  this._appSocket.getSocket().removeListener('ResponseStartStreamByAnonymous');
            this._appSocket.getSocket().on('ResponseStartStreamByAnonymous', (message) => {
                observer.next({type:'ResponseStartStreamByAnonymous',data: JSON.parse(message)});
            });

            if (this._appSocket.getSocket().listeners != null && this._appSocket.getSocket().listeners['streammingexceededtrigger'])  this._appSocket.getSocket().removeListener('streammingexceededtrigger');
            this._appSocket.getSocket().on('streammingexceededtrigger', (message) => {
                observer.next({type:'streammingexceededtrigger',data: JSON.parse(message)});
            });

            if (this._appSocket.getSocket().listeners != null && this._appSocket.getSocket().listeners['deviceonlinestatus'])  this._appSocket.getSocket().removeListener('deviceonlinestatus');
            this._appSocket.getSocket().on('deviceonlinestatus', (message) => {
                observer.next({type:'deviceonlinestatus',data: JSON.parse(message)});
            });

            if (this._appSocket.getSocket().listeners != null && this._appSocket.getSocket().listeners['livedevicerecordingstop'])  this._appSocket.getSocket().removeListener('livedevicerecordingstop');
            this._appSocket.getSocket().on('livedevicerecordingstop', (message) => {
                observer.next({type:'livedevicerecordingstop',data: JSON.parse(message)});
            });


      });
    }

    LiveviewDisconnect(){
        if (this._appSocket.getSocket().listeners['livedeviceoffline'])  this._appSocket.getSocket().removeListener('livedeviceoffline');
        if (this._appSocket.getSocket().listeners['ResponseStartStreamByAnonymous'])  this._appSocket.getSocket().removeListener('ResponseStartStreamByAnonymous');
        if (this._appSocket.getSocket().listeners['streammingexceededtrigger'])  this._appSocket.getSocket().removeListener('streammingexceededtrigger');
        if (this._appSocket.getSocket().listeners['deviceonlinestatus'])  this._appSocket.getSocket().removeListener('deviceonlinestatus');
    }

}
